// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchField_wrapper__YDeyi","wide":"SearchField_wide___4ESO","input":"SearchField_input__d7Zw_","button":"SearchField_button__QesJ4"};